import { ENUM_MortgagePartOverpaymentType, ENUM_MortgagePartUnderpaymentType } from '@api-new/common';
import {
  HTTP_CP_Mortgage,
  HTTP_CP_UpdateMortgage_ForIrregularPayments_Request,
  HTTP_CP_UpdateMortgage_ForIrregularPayments_Request_MortgagePartOverpayment,
  HTTP_CP_UpdateMortgage_ForIrregularPayments_Request_MortgagePartUnderpayment,
} from '@api-new/mortgageservice';
import { AddIrregularPaymentFormValues } from '@platform/mortgage-detail/components/add-irregular-payment-dialog/forms/add-irregular-payment.form';
import { MortgageIrregularPaymentTypeModel } from '@platform/mortgage-detail/components/add-irregular-payment-dialog/models/mortgage-irregular-payment.model';
import { OverpaymentUnderpaymentTypeEnum } from '@shared-lib/enums/overpayment-underpayment-type.enum';
import { dateToIsoStringWithoutTimezone } from '@shared-lib/utils/date-utils/date-to-iso-string-without-timezone';

export const addIrregularPaymentFormToHttpRequestAdapter = (
  mortgage: HTTP_CP_Mortgage,
  mortgagePartId: string,
  irregularPaymentType: MortgageIrregularPaymentTypeModel,
  addIrregularPaymentFormValues: AddIrregularPaymentFormValues,
): HTTP_CP_UpdateMortgage_ForIrregularPayments_Request => {
  const mortgagePart = mortgage.mortgageParts.find((part) => part.id === mortgagePartId);
  const overpayments: HTTP_CP_UpdateMortgage_ForIrregularPayments_Request_MortgagePartOverpayment[] =
    mortgagePart.mortgagePartOverpayments?.map((overpayment) => ({
      id: overpayment.id,
      mortgagePartOverpaymentType: overpayment.mortgagePartOverpaymentType,
      startDate: overpayment.startDate,
      endDate: overpayment.endDate,
      amount: overpayment.amount,
    })) ?? [];
  const underpayments: HTTP_CP_UpdateMortgage_ForIrregularPayments_Request_MortgagePartUnderpayment[] =
    mortgagePart.mortgagePartUnderpayments?.map((underpayment) => ({
      id: underpayment.id,
      mortgagePartUnderpaymentType: underpayment.mortgagePartUnderpaymentType,
      startDate: underpayment.startDate,
      endDate: underpayment.endDate,
      amount: underpayment.amount,
    })) ?? [];
  return irregularPaymentType === 'overpayment'
    ? {
        mortgageId: mortgage.id,
        mortgagePartId,
        mortgagePartOverpayments: [
          ...overpayments,
          {
            mortgagePartOverpaymentType:
              addIrregularPaymentFormValues.irregularPaymentRecurring ===
              OverpaymentUnderpaymentTypeEnum.OverpaymentUnderpaymentTypeRecurring
                ? ENUM_MortgagePartOverpaymentType.MORTGAGE_PART_OVERPAYMENT_TYPE_RECURRING
                : ENUM_MortgagePartOverpaymentType.MORTGAGE_PART_OVERPAYMENT_TYPE_ONE_TIME,
            startDate: dateToIsoStringWithoutTimezone(addIrregularPaymentFormValues.fromDate),
            endDate: dateToIsoStringWithoutTimezone(addIrregularPaymentFormValues.toDate),
            amount: addIrregularPaymentFormValues.amount,
          },
        ],
        mortgagePartUnderpayments: [...underpayments],
      }
    : {
        mortgageId: mortgage.id,
        mortgagePartId,
        mortgagePartOverpayments: [...overpayments],
        mortgagePartUnderpayments: [
          ...underpayments,
          {
            mortgagePartUnderpaymentType:
              addIrregularPaymentFormValues.irregularPaymentRecurring ===
              OverpaymentUnderpaymentTypeEnum.OverpaymentUnderpaymentTypeRecurring
                ? ENUM_MortgagePartUnderpaymentType.MORTGAGE_PART_UNDERPAYMENT_TYPE_RECURRING
                : ENUM_MortgagePartUnderpaymentType.MORTGAGE_PART_UNDERPAYMENT_TYPE_ONE_TIME,
            startDate: dateToIsoStringWithoutTimezone(addIrregularPaymentFormValues.fromDate),
            endDate: dateToIsoStringWithoutTimezone(addIrregularPaymentFormValues.toDate),
            amount: addIrregularPaymentFormValues.amount,
          },
        ],
      };
};
